import { FieldArray } from "formik";
import React from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { useOutletContext } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import useCourse from "src/hooks/useCourse";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { handleValidNumber } from "src/utils/validations/numberInput";

const WantToJoinOption = [
  {
    label: "Immediate",
    value: "IMMEDIATE",
  },
  {
    label: "After Date",
    value: "AFTER_DATE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

const CourseIntersted = () => {
  const [{ formikProps }]: any = useOutletContext();
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  //ALL COURSE
  const { course, isDataLoading: isCourseLoading } = useCourse();

  const CourseOption = course?.map((el: any) => {
    return {
      label: el?.courseName,
      value: el?._id,
      classroomFees: el?.classroomFees,
    };
  });
  return (
    <div className="xl:mr-2 mr-0">
      <div className="flex mt-4 gap-2 items-center">
        <ATMCheckbox
          extraClasses="font-semibold"
          checked={values?.course_not_clear}
          onChange={(newValue) => {
            setFieldValue('course_not_clear', newValue)
          }}
          label="Not Clear"
        ></ATMCheckbox>
        {values?.course_not_clear && (
          <ATMLoadingButton className="w-[130px]  bg-blue-400" type="button">
            <a
              href={
                "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
              }
              target="_blank"
              rel="noreferrer"
              className="text-link border-b border-link mr-3"
            >
              {" "}
              Open Script{" "}
            </a>
          </ATMLoadingButton>
        )}
      </div>
      <div className="mt-1 ">
        <FieldArray
          name="interested_course"
          render={({ push, remove }) => (
            <>

              {values?.interested_course?.map((doc: any, index: any) => {
                return (
                  <div key={index}>
                    <div className="flex justify-end mt-3">
                      <MdDelete
                        color="#F70913"
                        size={30}
                        className="pl-1 cursor-pointer"
                        onClick={() => {
                          showConfirmationDialog({
                            title: "Heads Up",
                            text: "Are you sure want to Delete this Course?",
                            icon: "question",
                            showCancelButton: true,
                            next: (result) => {
                              if (result.isConfirmed) {
                                remove(index)
                              }
                            }
                          })
                        }}
                      />
                    </div>
                    <div className="grid xl:grid-cols-4 md:grid-cols-2 xl:gap-6 gap-4">
                      <div>
                        <ATMSelect
                          name={`interested_course[${index}].course_name`}
                          value={
                            values?.interested_course?.[index]?.course_name
                          }
                          onChange={(e) => {
                            setFieldValue(
                              `interested_course[${index}].course_name`,
                              e
                            );
                            setFieldValue(
                              `interested_course[${index}].fees`,
                              e?.classroomFees
                            );
                          }}
                          options={CourseOption}
                          label="Course Name"
                          isLoading={isCourseLoading}
                        />
                      </div>
                      <div>
                        <ATMTextField
                          name={`interested_course[${index}].fees`}
                          value={values?.interested_course?.[index]?.fees}
                          onChange={(e) =>
                            handleValidNumber(e) &&
                            setFieldValue(
                              `interested_course[${index}].fees`,
                              e.target.value
                            )
                          }
                          label="Total Fees"
                          placeholder="Enter Total Fees"
                          onBlur={handleBlur}
                        />
                        <div className="flex gap-2 pt-1">
                          <p className="bg-slate-100 p-1 font-semibold text-[14px] rounded">   Online fees :&#8377; {values?.interested_course?.[index]?.online_fees || '-'}  </p>
                          <p className="bg-slate-100 p-1 font-semibold text-[14px] rounded">   Offline fees :&#8377; {values?.interested_course?.[index]?.offline_fees || '-'}  </p>
                        </div>
                      </div>

                      <div>
                        <ATMTextField
                          name={`interested_course[${index}].Offer_Price`}
                          value={
                            values?.interested_course?.[index]?.Offer_Price
                          }
                          onChange={(e) =>
                            handleValidNumber(e) &&
                            setFieldValue(
                              `interested_course[${index}].Offer_Price`,
                              e.target.value
                            )
                          }
                          label="Offer Price"
                          placeholder="Enter Offer Price"
                          onBlur={handleBlur}
                        />
                      </div>
                      <div>
                        <ATMTextField
                          name={`interested_course[${index}].remark`}
                          value={values?.interested_course?.[index]?.remark}
                          onChange={(e) =>
                            setFieldValue(
                              `interested_course[${index}].remark`,
                              e.target.value
                            )
                          }
                          label="Remark"
                          placeholder="Enter Remark"
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>


                  </div>
                );
              })}
              <div className="flex justify-end my-4">
                <p
                  className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                  onClick={() =>
                    push({
                      course_name: "",
                      fees: "",
                      Offer_Price: "",
                      remark: "",
                    })
                  }
                >
                  <AiOutlinePlus size={18} color="#0064C4" className="mr-2" />
                  Add Course
                </p>
              </div>
            </>
          )}
        />
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 xl:gap-6 gap-4">
        {/* Want To Join */}
        <div>
          <ATMSelectValue
            name="want_to_join"
            value={values.want_to_join}
            onChange={(newValue) => {
              setFieldValue("want_to_join", newValue)
              setFieldValue('want_to_join_remark', '')
              setFieldValue("after_date", '')
            }}
            onBlur={handleBlur}
            label="When Want To Join"
            placeholder="Select  When Want To Join"
            options={WantToJoinOption}
          />
        </div>

        {values?.want_to_join === 'AFTER_DATE' && <div>
          <ATMDatePicker
            format="DD/MM/YYYY"
            minDate={new Date()}
            name="after_date"
            value={values?.after_date || null}
            onChange={(newValue) => setFieldValue("after_date", newValue)}
            label="After Date"
          />
        </div>}

      </div>
      {/* Remark */}
      {values?.want_to_join === 'OTHER' && <div className='mt-3'>
        <ATMTextArea
          name='want_to_join_remark'
          value={values.want_to_join_remark}
          onChange={(e) => setFieldValue('want_to_join_remark', e)}
          label='Remark'
          placeholder='Enter Remark'
          onBlur={handleBlur}
        />
      </div>}
      <div className="flex justify-end mt-5">
        <ATMLoadingButton
          className="flex justify-end w-[70px] px-5"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default CourseIntersted;
